import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";
import Testimonial1 from "../element/testimonial1";
import CounterSection from "../element/counterSection";
import GoogleReviews from "../element/GoogleReviews";

var bnr3 = require("./../../images/contactus.png");
const exellence = require("../../images/quote.png");
const bg1 = require("./../../images/background/bg-video.png");
const bg2 = require("../../images/contactus.png");

const services = [
  {
    id: "service1",
    title: "Dependable & Trustworthy",
    bgColor: "#0ba350",
    icon: <i className="fas fa-handshake"></i>,
    description:
      "Clients trust us for consistent, reliable service with a personal touch.",
  },
  {
    id: "service2",
    bgColor: "#ff8000",
    title: "Advanced Techniques & Equipment",
    icon: <i className="fas fa-cogs"></i>,
    description: "We utilize cutting-edge technology for spotless results.",
  },
  {
    id: "service3",
    title: "Flexible Packages",
    bgColor: "#0152c2",
    icon: <i className="fas fa-sliders-h"></i>,
    description:
      "Customizable options to fit your specific requirements and schedule.",
  },
  {
    id: "service4",
    title: "Experienced Team",
    bgColor: "#9500c2",
    icon: <i className="fas fa-users"></i>,
    description:
      "Our trained professionals deliver meticulous cleaning and outstanding service.",
  },
];

const specialties = [
  {
    title: "Eco-Conscious Practices",
    description: "We use sustainable, eco-friendly products to ensure safety.",
  },
  {
    title: "Highly Trained Staff",
    description:
      "Our team receives regular training to deliver efficient, detail-oriented cleaning across various environments.",
  },
  {
    title: "Tailored Services",
    description:
      "Flexible, customizable solutions for each client’s unique needs and schedule.",
  },
  {
    title: "Commitment to Excellence",
    description:
      "Every space we clean is spotless, fresh, and inviting, with no corner overlooked.",
  },
];

class About1 extends Component {
  render() {
    return (
      <>
        <Header />

        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr overlay-black-middle text-center bg-pt"
            style={{ backgroundImage: "url(" + bnr3 + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry align-m text-center">
                <h1 className="text-white">About Us</h1>
                <div className="breadcrumb-row">
                  <ul className="list-inline">
                    <li>
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li>About Us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="content-block">
            {/* About Us Section */}
            <div id="about" className="section-full content-inner bg-white">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-12 m-b30">
                    <div className="our-story">
                      <span>Professional Cleaning Company Gold Coast</span>
                      <h2 className="title">
                        Complete Cleaning Solutions for Homes and Businesses
                      </h2>

                      <p>
                        Kangaroo Shine Property Services is a trusted cleaning
                        company providing professional cleaning services across
                        the Gold Coast. We specialise in residential cleaning,
                        bond cleaning, carpet steam cleaning, Airbnb cleaning
                        and commercial cleaning services tailored to both
                        homeowners and businesses.
                      </p>
                      <p>
                        If you are searching for reliable cleaning services Gold
                        Coast, our experienced team delivers detailed and
                        consistent results with a strong focus on quality,
                        hygiene and customer satisfaction. Every home is
                        different. That is why we customise our cleaning
                        services based on your needs. Whether you require
                        regular home cleaning or a one off deep clean, we
                        provide flexible options.
                      </p>
                      <p>
                        We understand that a clean environment improves comfort,
                        health and presentation. That is why we are committed to
                        delivering exceptional standards every time. Over time,
                        homes accumulate dust, grime and clutter that routine
                        cleaning may not fully remove. Our deep cleaning
                        services are designed to provide a complete and thorough
                        refresh of your home.
                      </p>
                      <p>
                        Our fully insured cleaners are professionals with a
                        minimum of five years of expertise in the field. The
                        team is passionate about providing the best cleaning
                        services for customers to create a hygienic and
                        favorable environment that meets the highest standards.
                      </p>

                      <Link to={"/contact/"} className="btn custom-quote-btn">
                        Get a quote
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 m-b30 our-story-thum">
                    <img
                      src={require("../../images/abtus.png")}
                      className="radius-sm"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonials */}
            <div
              id="testimonials"
              className="section-full wow fadeIn"
              data-wow-duration="2s"
              data-wow-delay="0.2s"
              style={{
                backgroundImage: "url(" + bg2 + ")",
                backgroundSize: "cover",
              }}
            >
              <GoogleReviews />
            </div>

            {/* Why Choose Us Section */}
            <div className="section-full bg-gray content-inner">
              <div className="container">
                <div className="section-head text-center">
                  <span className="title-box">Why Choose Us</span>
                  <h2 className="title-new">Shining Above the Rest</h2>
                  <p className="new-des">
                    At Kangaroo Shine, we don’t just clean—we create
                    environments that inspire confidence. With expert
                    technicians, eco-friendly practices, and an unwavering
                    commitment to quality, we go above and beyond to deliver
                    outstanding results for every client. Our customer-first
                    approach ensures that your satisfaction is always our top
                    priority.
                  </p>
                </div>
                <div className="section-content row">
                  {services.map((service, index) => (
                    <ServiceCard
                      key={index}
                      icon={service.icon}
                      bgColor={service.bgColor}
                      title={service.title}
                      description={service.description}
                      index={index}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Specialty Section */}
            {/* <div className="section-full overlay-black-middle bg-secondry content-inner-2">
              <div className="container">
                <div className="section-head text-white text-center">
                  <span className="title-box">Our Specialty</span>
                  <h2 className="title-new">Cleaning with Precision</h2>
                  <p>
                    We specialize in cleaning high-demand commercial and
                    industrial spaces, where precision and efficiency are
                    essential. Whether it's maintaining large facilities, deep
                    cleaning after major projects, or managing complex
                    workspaces, we deliver exceptional results with care and
                    attention to detail.
                  </p>
                </div>

                <div className="section-content specialties p-b0">
                  <div className="row ">
                    {specialties.map((specialty, index) => (
                      <div
                        className="col-lg-6 col-md-6 col-sm-6 mb-4"
                        key={index}
                      >
                        <div className="border rounded-sm specialty shadow-lg h-100 p-4">
                          <div className="mb-3 specialty-icon">
                            {index === 0 && (
                              <i className="fas fa-leaf text-white"></i>
                            )}
                            {index === 1 && (
                              <i className="fas fa-user-graduate text-white"></i>
                            )}
                            {index === 2 && (
                              <i className="fas fa-cogs text-white"></i>
                            )}
                            {index === 3 && (
                              <i className="fas fa-thumbs-up text-white"></i>
                            )}
                          </div>
                          <div className=" specialty-conent">
                            <h5 className="card-title text-xl  text-secondry font-weight-bold ">
                              {specialty.title}
                            </h5>
                            <p className="card-text text-white text-base">
                              {specialty.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

const ServiceCard = ({ icon, title, description, bgColor, index }) => {
  return (
    <div className="col-md-3 col-lg-3 col-sm-12 service-box style3 chooce-card">
      <div className="icon-bx-wraper box-flex">
        <div
          className="icon-lg choose-icon"
          style={{ backgroundColor: `${bgColor}` }}
        >
          <Link to="#" className="icon-cell">
            {icon}
          </Link>
        </div>
        <div className="icon-content text-center">
          <h2 className="dlab-tilte">{title}</h2>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default About1;
